/**
 * [Pure] Compare two values using string comparator.
 * @param initialValue - First value to compare.
 * @param comparator - Comparator string (ex. '==', '>').
 * @param compareValue - Second value to compare.
 */
export function compare(initialValue: any, comparator: string, compareValue?: any): boolean {
    // Turn currency into numbers.
    if (typeof initialValue === "string" && initialValue[0] === "$") initialValue = parseInt(initialValue.replace(/[$,]/g, ""));
    if (typeof compareValue === "string" && compareValue[0] === "$") compareValue = parseInt(compareValue.replace(/[$,]/g, ""));

    if (comparator === "!") return [null, "", undefined, false].indexOf(initialValue) > -1;
    if (comparator === "!!") return [null, "", undefined, false].indexOf(initialValue) < 0;
    if (comparator === "==") return initialValue == compareValue;
    if (comparator === "!=") return initialValue != compareValue;
    if (comparator === "<") return initialValue < compareValue;
    if (comparator === ">") return initialValue > compareValue;

    if (comparator === "regex") {
        if (!initialValue) return false;
        if (typeof initialValue === "number") initialValue = initialValue.toString();
        return initialValue.match(new RegExp(compareValue));
    }
    return false;
}
